import React from 'react'
import './Navbar.css'
import SideNav, {  NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import Home from './Home';
import Calendar from './Calendar';
import Statistics from './Statistics'
import logo from '../assets/logo.png';
import Logout from './Logout';
import store from '../redux';




class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
          expanded : false,
          display: 'Home',
          isLogin: false
        }
    } 

    componentDidMount() {
        store.subscribe(() => 
        {
            this.setState({isLogin : store.getState().state !== ''})
            store.getState().route !== '' ? this.setState({display : store.getState().route}) : console.log()
        }    
        )
    }
    render() {
        return (
            <div>
                <div className="navbar">
                    <SideNav 
                    expanded={this.state.expanded}
                    onToggle={(expanded) => {
                        this.setState({ expanded });
                    }} 
                    onSelect={(selected) => {
                        this.setState({display : selected})
                    }} >
                        <SideNav.Toggle />
                        <SideNav.Nav>
                            {this.state.expanded ? <h5>Resolusi & Apresiasi</h5> : ''}
                            <img src={logo} className="img-fluid logo" alt="" />
                            <NavItem eventKey="Home" active={this.state.display === 'Home'}>
                                <NavIcon>
                                    <i className="fa fa-fw fa-home" style={{ fontSize: '1.75em' }} />
                                </NavIcon>
                                <NavText>
                                    Beranda
                                </NavText>
                            </NavItem>
                            {this.state.isLogin ? 
                            <NavItem eventKey="Calendar" active={this.state.display === 'Calendar'}>
                                <NavIcon>
                                    <i className="fa fa-fw fa-calendar" style={{ fontSize: '1.75em' }} />
                                </NavIcon>
                                <NavText>
                                    Jadwal
                                </NavText>
                            </NavItem>
                            : ''}
                            {this.state.isLogin ?
                            <NavItem eventKey="Charts" active={this.state.display === 'Charts'}>
                                <NavIcon>
                                    <i className="fa fa-fw fa-bar-chart" style={{ fontSize: '1.75em' }} />
                                </NavIcon>
                                <NavText>
                                    Statistik
                                </NavText>
                            </NavItem>
                            : ''}
                            {this.state.isLogin ?
                            <Logout />
                            : ''}
                            
                        </SideNav.Nav>
                    </SideNav>
                </div>
                {this.state.display === 'Home' ? <Home expanded={this.state.expanded}/> : ''}
                {this.state.display === 'Calendar' ? <Calendar expanded={this.state.expanded}/> : ''}
                {this.state.display === 'Charts' ? <Statistics expanded={this.state.expanded}/> : ''}
                {this.state.display === 'Logout' ? <h1>Logout</h1> : ''}
                
            </div>
        )
    }
}

export default Navbar;